import React, { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { postApi } from '../../utils/api/api';
import { showToast } from '../../utils/toast';
import "./Contact.css";
import { useLanguage } from "../../contexts/LanguageContext";

import bgImg from "../../assets/images/contact-bg.jpg"
const ContactUs = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
     setErrors((prev) => ({ ...prev, [name]: '' }));
  };

    const validateForm = () => {
  const { name, email, phone, message } = formData;
  const newErrors = {};

  // Name
  if (!name?.trim()) {
    newErrors.name = 'Name is required';
  } else if (name.length > 255) {
    newErrors.name = 'Name must be less than 255 characters';
  }

  // Email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email?.trim()) {
    newErrors.email = 'Email is required';
  } else if (!emailRegex.test(email)) {
    newErrors.email = 'Please enter a valid email address';
  }

  // Phone (numbers only, max 12)
  const phoneRegex = /^[0-9]+$/;
  if (!phone?.trim()) {
    newErrors.phone = 'Phone number is required';
  } else if (!phoneRegex.test(phone)) {
    newErrors.phone = 'Phone number must contain only digits';
  } else if (phone.length > 12) {
    newErrors.phone = 'Phone number must be at most 12 digits';
  }

  // Message
  if (!message?.trim()) {
    newErrors.message = 'Message is required';
  } else if (message.length > 500) {
    newErrors.message = 'Message must be less than 500 characters';
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
     if (!validateForm()) {
      // showToast('error', t('errors.validationFailed', 'Please correct the errors in the form.'));
      return;
    };
    setLoading(true);

    try {
      const response = await postApi('contact-save', formData);
      if (response.success) {
        showToast('success', 'Message sent successfully!');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        showToast('error', response.message || 'Failed to send message');
      }
    } catch (error) {
      showToast('error', error.message || 'An error occurred while sending the message');
    } finally {
      setLoading(false);
    }
  };

// const Contact = () => {
//   const { t } = useLanguage();
//   const [formData, setFormData] = useState({ name: "", email: "", message: "" });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted:", formData);
//     alert("Thank you! Your message has been sent.");
//     setFormData({ name: "", email: "", message: "" });
//   };

  return (
    <section className="contact-section"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="contact-title">
            {t("header.contact")}...
          </h2>
          {/* <p className="contact-subtitle">
            We'd love to hear from you. Reach out with any questions or inquiries.
          </p> */}
        </div>

        {/* Main content */}
        <div className="contact-content">
          {/* Left: Contact Form */}
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input
                 type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    error={errors.name}
                 // type="text"
                  // name="name"
                  // value={formData.name}
                  // onChange={handleChange}
                  // placeholder="Your Name"
                  // required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                 type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    error={errors.email}
                 
                 // type="email"
                  // name="email"
                  // value={formData.email}
                  // onChange={handleChange}
                  // placeholder="Your Email"
                  // required
                />
              </div>
              <div className="form-group">
                <label>Contact</label>
                <input
                 type="text"
                    name="phone"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    error={errors.phone}
                 
                //  type="number"
                //   name="number"
                //   value={formData.number}
                //   onChange={handleChange}
                //   placeholder="Your Contact"
                //   required
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  
                   row="6"
                    placeholder="Your Message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    error={errors.message}
                  // name="message"
                  // value={formData.message}
                  // onChange={handleChange}
                  // placeholder="Your Message"
                  // rows="5"
                  // required
                />
              </div>
              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>

          {/* Right: Contact Info */}
          <div className="contact-info">
            <div className="contact-card tilt-card">
              <div className="contact-icon gradient-icon">
                <Phone size={24} />
              </div>
              <div>
                <h4>Phone</h4>
                <p>+62 82180-879400 </p>
              </div>
            </div>

            <div className="contact-card tilt-card">
              <div className="contact-icon gradient-icon">
                <Mail size={24} />
              </div>
              <div>
                <h4>Email</h4>
                <p>info@tokoyarn.com</p>
              </div>
            </div>

            <div className="contact-card tilt-card">
              <div className="contact-icon gradient-icon">
                <MapPin size={24} />
              </div>
              <div>
                <h4>Address</h4>
                <p className="text-base text-body-secondary">
                    The Boulevard Office<br/>
                    5th floor / Room C-2<br/>
                    Jl. KH Fakhrudin Raya No. 5,<br/>
                    Kampung Bali, Tanah Abang<br/>
                    Jakarta Pusat - DKI Jakarta
                </p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
